"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = WebView;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _excluded = ["link", "height", "width"];
function WebView(props) {
  var link = props.link,
    height = props.height,
    width = props.width,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement("iframe", {
    src: link,
    height: height,
    width: width
  });
}
WebView.defaultProps = {
  height: 800,
  width: '100%'
};